// const httpss = 'http://localhost:3004';
// const httpss = 'https://ticket.myu.vn';
// const httpss = 'https://mail.myu.vn';
const httpss = 'https://dashboard.myu.vn';

export { httpss };